import type { ITraveler, PersonId, ProductType } from "@hopper-b2b/types";
import type { DoneInvokeEvent } from "xstate";
import type { TravelerError } from "./types";

export enum TravelerEventTypes {
  DELETE_TRAVELER = "DELETE_TRAVELER",
  SET_CURRENT_TRAVELER = "SET_CURRENT_TRAVELER",
  CLEAR_TRAVELER_INFORMATION_ERROR = "CLEAR_TRAVELER_INFORMATION_ERROR",
  SET_TRAVELER_ERROR = "SET_TRAVELER_ERROR",
  ON_INFANT_MODAL_CONTINUE = "ON_INFANT_MODAL_CONTINUE",
  CLEAR_CURRENT_INFANT_ID = "CLEAR_CURRENT_INFANT_ID",
  SET_CURRENT_INFANT_ID = "SET_CURRENT_INFANT_ID",
  OPEN_TRAVELER_PICKER = "OPEN_TRAVELER_PICKER",
  OPEN_TRAVELER_FORM = "OPEN_TRAVELER_FORM",
  OPEN_TRAVELER_DELETE_MODAL = "OPEN_TRAVELER_DELETE_MODAL",
  VALIDATE_TRAVELER = "VALIDATE_TRAVELER",
  ADD_TRAVELER = "ADD_TRAVELER",
  COMPLETE = "COMPLETE",
  GO_IDLE = "GO_IDLE",
  NEXT = "NEXT",
  SELECT_TRAVELER = "SELECT_TRAVELER",
  UPDATE_TRAVELER = "UPDATE_TRAVELER",
  PREVIOUS = "PREVIOUS",
}

export interface DeleteTravelerEvent {
  type: TravelerEventTypes.DELETE_TRAVELER;
  travelerId: PersonId;
}

export interface SetCurrentTravelerEvent {
  type: TravelerEventTypes.SET_CURRENT_TRAVELER;
  // clear current traveler when given null or undefined
  traveler: ITraveler | null;
}

export interface SetCurrentInfantIdEvent {
  type: TravelerEventTypes.SET_CURRENT_INFANT_ID;
  // clear current infant id when given null
  infantId: PersonId | null;
}

export interface OnInfantModalContinueEvent {
  type: TravelerEventTypes.ON_INFANT_MODAL_CONTINUE;
  seatType: "OwnSeat" | "OnLap" | "NotTraveling";
}

export interface ClearTravelerInformationError {
  type: TravelerEventTypes.CLEAR_TRAVELER_INFORMATION_ERROR;
}

export interface OpenTravelerPickerEvent {
  type: TravelerEventTypes.OPEN_TRAVELER_PICKER;
}

export interface OpenTravelerFormEvent {
  type: TravelerEventTypes.OPEN_TRAVELER_FORM;
}

export interface OpenTravelerDeleteModalEvent {
  type: TravelerEventTypes.OPEN_TRAVELER_DELETE_MODAL;
}

export interface SelectTravelerEvent {
  type: TravelerEventTypes.SELECT_TRAVELER;
  travelerId: PersonId;
  singleTravelerWorkflow?: boolean;
  onUpdate?: boolean;
}

export interface AddTravelerEvent {
  type: TravelerEventTypes.ADD_TRAVELER;
}
export interface UpdateTravelerEvent {
  type: TravelerEventTypes.UPDATE_TRAVELER;
  traveler: ITraveler;
  onUpdate?: boolean;
  singleTravelerWorkflow?: boolean;
}

export interface GoIdleEvent {
  type: TravelerEventTypes.GO_IDLE;
}

export interface NextEventType {
  type: TravelerEventTypes.NEXT;
  productType: ProductType;
}

export interface PreviousEventType {
  type: TravelerEventTypes.PREVIOUS;
}

export interface ValidateUserTravelerEvent {
  type: TravelerEventTypes.VALIDATE_TRAVELER;
  travelerId?: string;
  singleTravelerWorkflow?: boolean;
}

export type TravelerEvents =
  | AddTravelerEvent
  | ClearTravelerInformationError
  | DoneInvokeEvent<TravelerError>
  | DeleteTravelerEvent
  | GoIdleEvent
  | NextEventType
  | ValidateUserTravelerEvent
  | OpenTravelerFormEvent
  | OpenTravelerDeleteModalEvent
  | OpenTravelerPickerEvent
  | SelectTravelerEvent
  | SetCurrentTravelerEvent
  | SetCurrentInfantIdEvent
  | OnInfantModalContinueEvent
  | UpdateTravelerEvent
  | PreviousEventType;
